export default __webpack_public_path__ + "static/namami-gange-logo-ca218b07c1633c75d6cc56a247f6392a.png";